import { withStyles } from '@material-ui/core';
import reportConstants from '../../constants';

const styles = {
  mainContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  badgeContainer: {
    padding: 2,
    marginRight: 4,
    width: 28,
    height: 28,
    margin: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600
  },
  delivery: {
    border: '1px solid #000',
    borderRadius: '20px'
  },
  pickup: {
    border: '1px solid #000',
    borderRadius: '4px'
  }
};

const StopActivityBadge = ({ classes, stopSequence, stopName, activityName, stopType }) => {
  return (
    <div className={classes.mainContainer}>
      <div
        className={`${classes.badgeContainer} ${
          stopType === reportConstants.DISPATCH_STOP_TYPES.DELIVERY
            ? classes.delivery
            : classes.pickup
        }`}>
        {stopSequence}
        {activityName}
      </div>
      <div>{stopName}</div>
    </div>
  );
};

export default withStyles(styles)(StopActivityBadge);
